export enum RoleMappings {
    Admin = 1,
    Doctor = 2,
    Patient = 3,
    Contributor = 4
}
